export default {"src":"/_next/static/media/403_Manny.16e8b609.svg","height":241,"width":304};